import React, { useState, useEffect } from 'react';
import SubmitButton from '../components/SubmitButton';
import SearchBarCP from '../components/SearchBarCP';
import LoadingSpinner from '../components/LoadingSpinner';
import SubMenu from '../components/SubMenu';
import DateFormat from '../components/DateFormat';
import ModalNotesCp from '../components/ModalNotesCp';
import { toast } from 'react-toastify';
import FileLocation from '../components/FileLocation';
import { useUserData } from '../context/UserData';
import Modal from '../components/Modal';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { NavLink, useNavigate } from 'react-router-dom';
import PhoneNumber from '../components/PhoneNumber';
import { ArrowPathIcon, ChatBubbleBottomCenterIcon, CheckBadgeIcon } from '@heroicons/react/24/outline';
import HeadingCp from '../components/HeadingCp';
import LegendCP from '../components/LegendCP';
import ServiceInvoiceFileLocation from '../components/ServiceInvoiceFileLocation';
import ServiceGenFileLocation from '../components/ServiceGenFileLocation';
import { DocumentCheckIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import SelectEmployeeCp from '../components/SelectEmployeeCp';
import Truncate from '../components/Truncate';
import ModalWindow from '../components/ModalWindow';
import { TrashIcon } from '@heroicons/react/20/solid';
import SlideOverPanel from '../components/SlideOverPanel';
import SelectParts from '../components/SelectParts';
import { PhotoIcon } from '@heroicons/react/24/solid';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const ServiceCallList = () => {
  const [detailsModal, setDetailsModal] = useState({ open: false, object: null });

  // State for Google Drive images
  const [imagesModalOpen, setImagesModalOpen] = useState(false);
  const [driveImages, setDriveImages] = useState([]);

 // -- Hold modal -----------------------------
  const [showHoldModal, setShowHoldModal] = useState(false);
  const [holdContractId, setHoldContractId]   = useState(null);

  //for adding hours
  const [showHrsModel, setShowHrsModel] = useState(false);
  const [hoursId, setHoursId] = useState(null);
  const [callId, setCallId] = useState(null);
  const [techId, setTechId] = useState(null);
  const [assignedCalls, setAssignedCalls] = useState([]);  

  const [notesIdOpen, setNotesIdOpen] = useState(null); 
  //for the modal popup
  const [additionTechLink, setAdditionTechLink] = useState([]);

  const [addTech, setAddTech] = useState({additional_tech:''});
  const [selectedService, setSelectedService] = useState(null);
  const [additionTech, setAdditionTech] = useState([]);

  const [selectEmployee, setSelectedEmployee] = useState(false);
  const [completedHours, setCompletedHours] = useState([]);

  const [isModalOpenLead, setIsModalOpenLead] = useState(null)

  const apiUrl = process.env.REACT_APP_API_URL;
  const api = `${apiUrl}/service_crud.php`;
  const userData = useUserData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedServiceCall, setSelectedServiceCall] = useState(null);
  const [serviceCallForm, setServiceCallForm] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [filterItems, setFilterItems] = useState([]);
  const [fetchItems, setFetchItems] = useState([]);
  const [filterStatus, setFilterStatus] = useState('PENDING');
  const [filterEmployee, setFilterEmployee] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [editingTech, setEditingTech] = useState({}); // To track which row is being edited
  
  const [file, setFile] = useState(null);
  
  const [selectInvoiceFile, setSelectInvoiceFile] = useState(null);
  const [isModalFileOpen, setIsModalFileOpen] = useState(false);
  
  const [selectGenFile, setSelectGenFile] = useState(null);
  const [isModalFileGenOpen, setIsModalFileGenOpen] = useState(false);

  const [partsList, setPartsList] = useState([]);
  const [parts, setParts] = useState([]);
  const [selectParts, setSelectedParts] = useState(null); 
  const [servicePart, setServicePart] = useState({ part: '', quantity: 1 });
  const [showPartsModel, setShowPartsModel] = useState(false);  
  const [showTechComment, setShowTechComment] = useState(false);
  const [totalCalls, setTotalCalls] = useState(0);

  //tech notes updates
  const [editTechNotesId, setEditTechNotesId] = useState(null); // ID of service call being edited
  const [techNotesValue, setTechNotesValue] = useState('');

  //for slide over panel
  const [openPanel, setOpenPanel] = useState(false)

  const [scheduleSortDir, setScheduleSortDir] = useState('asc'); // 'asc' | 'desc'

  
  useEffect(() => {
    fetchServiceCalls();
  }, [apiUrl, navigate]);

  useEffect(() => {
    setLoading(true);
    const employees = async () => {
      try {
        const response = await axios.get(`${apiUrl}/service_crud.php?employee_list=true`, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
        const serviceCalls = Array.isArray(response.data) ? response.data : [];
        if (serviceCalls.length === 0) {
          toast.error("No service calls found!", { position: "top-center" });
        }
        setEmployees(response.data);
        
        //addition tech
        const additionTech = Array.isArray(response.data.add_tech) ? response.data.add_tech : [];
        setAdditionTech(additionTech || [])

      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("Session expired. Please login again.", { position: "top-center" });
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", { position: "top-center" });
        }
      } finally {
        setLoading(false);
      }
    };

    employees();
  }, [apiUrl, navigate]); 

  useEffect(() => {
    let filtered;
    if (filterStatus === 'ALL') {
      filtered = fetchItems;
    } else if (filterStatus === 'READY') {
      filtered = fetchItems.filter(item => item.INVOICE === filterStatus);
    } else if (filterStatus === 'VOID') {
      filtered = fetchItems.filter(item => (item.STATUS).toUpperCase() === 'VOID');
    } 
    else if (filterStatus === 'ASSIGNED') {
      filtered = fetchItems.filter(
        item => (item.STATUS || '').toUpperCase() === 'ASSIGNED' || 
        (item.STATUS || '').toUpperCase() === 'ACTIVATED');
    }
    else if (filterStatus === 'invoiced') {
      filtered = fetchItems.filter(item => parseInt(item.billing_complete) === 1);
    }
    else if (filterStatus === 'not_invoiced') {
      filtered = fetchItems.filter(item => parseInt(item.billing_complete) === 0 && 
                                           item.STATUS !== 'ASSIGNED' && 
                                           item.STATUS !== 'PENDING' && 
                                           item.STATUS !== 'VOID' && 
                                           item.STATUS !== 'ACTIVATED');
    }
    else {
      filtered = fetchItems.filter(item => (item.STATUS || '').toUpperCase() === filterStatus.toUpperCase());
    }
  
    setFilterItems(filtered);
  }, [filterStatus, fetchItems]);
  
  const fetchServiceCalls = async () => {
    setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/service_crud.php?getList=1`, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
        const serviceCalls = Array.isArray(response.data.calls) ? response.data.calls : [];
        const serviceCallsTotal = response.data.totals || {};
        if (serviceCalls.length === 0) {
          toast.error("No service calls found!", { position: "top-center" });
        }
        setTotalCalls(serviceCallsTotal);
        setFilterItems(serviceCalls);
        setFetchItems(serviceCalls);
        // Set initial filterStatus based on priorities
        const hasPending = serviceCalls.some(item => item.STATUS === 'PENDING');
        const hasAssigned = serviceCalls.some(item => item.STATUS === 'ASSIGNED' || item.STATUS === 'ACTIVATED');
        const hasCompleted = serviceCalls.some(item => item.STATUS === 'COMPLETED');

        if (hasPending) {
          setFilterStatus('PENDING');
        } else if (hasAssigned) {
          setFilterStatus('ASSIGNED');
        } else if (hasCompleted) {
          setFilterStatus('COMPLETED');
        }      
          
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("Session expired. Please login again.", { position: "top-center" });
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", { position: "top-center" });
        }
      } finally {
        setLoading(false);
      }
  };  

  const handleNotesView = (id) => {
    setNotesIdOpen(id);
  };

  const handleTechFilter = async (techName) => {

    const bodyData = {
      status: "filterTech",
      techName: techName,
    }
      setLoading(true)
      try {
        const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
          headers: { 'Content-Type': 'application/json' },
        });        
        if(response.data.success) {
          const serviceCalls = Array.isArray(response.data.success) ? response.data.success : []; 
          setFilterItems(serviceCalls);
          setFetchItems(serviceCalls);
          // setFilterStatus('All')
        }
        else {
          toast.info("Found no calls for "+techName, { position: "top-center" });
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("Session expired. Please login again.", {
          position: "top-center"
          });
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
          position: "top-center"
          });
        }
      } finally {
        setLoading(false);
      }
    
  }

  const handleRemoveTech = async (addition_tech_id) => {
  setLoading(true);
  const bodyAddData = {
    status: "removeAdditionalTech",
    addition_tech_id: addition_tech_id,
  };

  try {
    const response = await axios.post(`${apiUrl}/service_crud.php`, bodyAddData, {
      headers: { 'Content-Type': 'application/json' }
    });
    if (response.data[0] === 'success') {
      setSelectedService(prevService => ({
        ...prevService,
        add_tech: prevService.add_tech.filter(tech => tech.id !== addition_tech_id), // Remove the technician from the array
      }));
      window.location.reload();
      toast.success('Tech removed!', { position: 'top-center' });
    } else {
      toast.info("Failed to remove tech", { position: "top-center" });
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      toast.error("Session expired. Please login again.", { position: "top-center" });
      navigate('/login');
    } else if (error.response && error.response.status === 403) {
      toast.error("Oops!! You don't have access to this area. Speak to the CFO.", { position: 'top-center' });
    }
  } finally {
    setLoading(false);
  }
  };

  const handleFilter = async () => {
    // Ensure date range is provided
    if (!dateFrom || !dateTo) {
      toast.error("Please provide both start and end dates.", { position: "top-center" });
      return;
    }

    setLoading(true);
    const bodyData = {
        status: 'getFilter',
        date_from: dateFrom,
        date_to: dateTo,
        filter_status: filterStatus,
        tech: filterEmployee,
    }
    try {
      // Fetch filtered data from the server
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });
      const filteredServiceCalls = Array.isArray(response.data) ? response.data : [];
      if (filteredServiceCalls.length === 0) {
        toast.info("No service calls found for the selected criteria.", { position: "top-center" });
      }
      setFilterItems(filteredServiceCalls);
    } catch (error) {
      toast.error("Error fetching filtered data.", { position: "top-center" });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteServiceCall = async (id) => {
    const bodyData = {
      status: "delete",
      id: id,
    };

    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.data[0] === 'success') {
        // Filter out the deleted service call from the list
        setFilterItems((prevItems) =>
          prevItems.filter((item) => item.id !== id) // Remove the deleted service call
        );
        toast.success('Service call successfully deleted!', {
          position: 'top-center',
        });
      } else {
        toast.info("Failed to delete the service call.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center",
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleVoidServiceCall = async (id) => {
    const bodyData = {
      status: "voidServiceCall",
      id: id,
    };
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.data[0] === 'success') {
          setFilterItems(prevItems =>
            prevItems.map(item =>
              item.id === id ? { ...item, STATUS:'VOID' } : item // Set TECH to full name
            )
          );
        toast.success('Service call successfully voided!', {
          position: 'top-center',
        });
      } else {
        toast.info("Failed to void the service call.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center",
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClearAssigned = async (id) => {
    const bodyData = {
      status: "clearAssigned",
      id: id,
    };
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.data[0] === 'success') {
          setFilterItems(prevItems =>
            prevItems.map(item =>
              item.id === id ? { ...item, TECH:'', STATUS: 'PENDING' } : item // Set TECH to full name
            )
          );
          setFetchItems(prevItems =>
            prevItems.map(item =>
              item.id === id ? { ...item, TECH:'', STATUS: 'PENDING' } : item // Set TECH to full name
            )
          );
        toast.success('Service call successfully cleared!', {
          position: 'top-center',
        });
      } else {
        toast.info("Failed to clear the service call.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center",
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleReschedule = async (id) => {
    const bodyData = {
      status: "reschedule",
      id: id,
    };
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });    
      if (response.data[0] === 'success') {
          setFilterItems(prevItems =>
            prevItems.map(item =>
              item.id === id ? { ...item, TECH:'', STATUS: 'COMPLETED', NOTES: `Main call re-assgined to log:${response.data[1]}`} : item // Set TECH to full name
            )
          );
        toast.success('Service call successfully rescheduled!', {
          position: 'top-center',
        });
      } else {
        toast.info("Failed to re-schedule the service call.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center",
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCompleteStatus = async (id) => {
    const bodyData = {
      status: "completeStatus",
      id: id,
    };
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });    
      if (response.data[0] === 'success') {
          setFilterItems(prevItems =>
            prevItems.map(item =>
              item.id === id ? { ...item, STATUS: 'COMPLETED'} : item // Set TECH to full name
            )
          );
        toast.success('Service call status to completed!', {
          position: 'top-center',
        });
      } else {
        toast.info("Failed to change status of service call.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center",
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCheckedReady = async (id) => {
    const bodyData = {
      status: "checkedReady",
      id: id,
    };
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });    
      if (response.data[0] === 'success') {
          setFilterItems(prevItems =>
            prevItems.map(item =>
              item.id === id ? { ...item, INVOICE: 'READY'} : item // Set TECH to full name
            )
          );
        toast.success('Service call ready for invoice!', {
          position: 'top-center',
        });
      } else {
        toast.info("Failed to change invoice status.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center",
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCharge = async (id, type) => {
    const bodyData = {
      status: "handleCharge",
      id: id,
      type: type
    };
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });    
      if (response.data[0] === 'success') {
          setFilterItems(prevItems =>
            prevItems.map(item =>
              item.id === id ? { ...item, TYPE: type} : item // Set TECH to full name
            )
          );
        toast.success('Service call - '+type+'!!', {
          position: 'top-center',
        });
      } else {
        toast.info("Failed to change type.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center",
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleIncompleteStatus = async (id, type) => {
    const bodyData = {
      status: "incompleteStatus",
      id: id
    };
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });    
      if (response.data[0] === 'success') {
          setFilterItems(prevItems =>
            prevItems.map(item =>
              item.id === id ? { ...item, STATUS: "INCOMPLETE"} : item 
            )
          );
        toast.success('Service call status changed to incomplete', {
          position: 'top-center',
        });
      } else {
        toast.info("Failed to change to status.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center",
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

   // Handle input changes when adding a new reimbursement
  // const handleNewInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setNewTechAdding((prev) => ({ ...prev, [name]: value }));
  // }; 

  //handle tech notes update
  const handleTechNotesUpdate = async (id, techNotes) => {
    setEditTechNotesId(id);
    setTechNotesValue(techNotes || '')
  }

  const handleAdditionalTech = async (employeeId, employeeName, serviceCall) => { 
    // setLoading(true);
    const isAlreadyAdded = additionTech.some((tech) => parseInt(tech.tech_id) === parseInt(employeeId)); // Convert both to numbers
    if (isAlreadyAdded) {
      toast.info('This technician has already been added.', { position: 'top-center' });
      setLoading(false);
      return; // Prevent adding duplicate tech
    }
    if ( employeeName === serviceCall.TECH) {
      toast.info(serviceCall.TECH+' is the lead tech on the call.', { position: 'top-center' });
      setLoading(false);
      return; // Prevent adding duplicate tech
    }
    const bodyData = {
      status: "additionalTech",
      tech_id: employeeId,
      id: serviceCall.id,
      tech_name: employeeName
    };
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data[0] === 'success') {
         window.location.reload();
        // const newTech = Array.isArray(response.data[1]) ? response.data[1] : [response.data[1]];
        // setAdditionTech((prevTech) => [...prevTech, ...newTech]);
        toast.success('Tech added!', {
          position: 'top-center',
        });
      } else {
        toast.info("Failed to add tech", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center"
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center"
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleUnvoidServiceCall = async (id) => {
    setLoading(true);
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, {
        status: "unvoidServiceCall",
        id: id,
      }, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.data[0] === 'success' || response.data.success) {
        setFilterItems(prevItems =>
          prevItems.map(item =>
            item.id === id ? { ...item, STATUS: 'PENDING' } : item // Or whatever status you want to restore to
          )
        );
        toast.success('Service call successfully unvoided!', {
          position: 'top-center',
        });
      } else {
        toast.info("Failed to unvoid the service call.", { position: "top-center" });
      }
    } catch (error) {
      toast.error("Error while unvoiding.", { position: 'top-center' });
    } finally {
      setLoading(false);
    }
  };
  

  const getLinksForJob = (object) => {
      const links = [
        { name: 'Edit Call', click: () => navigate(`/service_new/${object.id}`) },
        { name: 'Upload File', click: () => {setIsModalFileGenOpen(true); setSelectGenFile(object.id); }, key: `void-${object.id}` },
      ];

      if(object.STATUS === 'COMPLETED')
      {
        //edit service ticket option
        if(object.INVOICE === null){
          links.push({
            name: 'Checked(Ready)',
            click: () => handleCheckedReady(object.id),
            key: `invoicex-${object.id}`
          });          
          
          links.push({
            name: 'Incomplete',
            click: () => handleIncompleteStatus(object.id),
            key: `incomplete-${object.id}`
          });
        }

        if (object.INVOICE === 'READY') {
          links.push({
            name: 'Upload Invoice',
            click: () => {
              setIsModalFileOpen(true);  // Open the modal when clicked
              setSelectInvoiceFile(object.id);  // Set the selected invoice genFile
            },
            key: `uploadfile-${object.id}`
          });
          links.push({
            name:  object.billing_complete === 1 ? 'Not Invoiced' : 'Invoiced',
            click: () => { handleBillingComplete(object.id,  object.billing_complete === 1 ? 0 : 1);},
            key: `invoiced-${object.id}`
          });
        }

        links.push({
          name: object.TYPE === 'NO CHARGE' ? 'Charge' : 'No Charge',
          click: () => handleCharge(object.id, object.TYPE === 'NO CHARGE' ? 'CHARGE' : 'NO CHARGE'),
          key: `type-${object.id}`
        }); 

        links.push({
          name: 'Update Tech Notes',
          click: () => handleTechNotesUpdate(object.id, object.TECHNOTES),
          key: `type-${object.id}`
        }); 

        links.push({
          name: 'Update Hours',
          click: () => handleHrsUpdate(object),
          key: `hours-${object.id}`
        }); 

        links.push({
          name: 'Update Parts',
          click: () => handlePartsUpdate(object.id),
          key: `hours-${object.id}`
        }); 

      }
      else
      {
        if (object.STATUS === 'ASSIGNED') {
          links.push({
            name: 'Clear Assigned',
            click: () => handleClearAssigned(object.id),
            key: `clear-${object.id}`
          });
          links.push({
            name: 'Add Helper',
            click: () => {
              setSelectedServiceCall(object); // Set the currently selected service call
              setIsModalOpen(true);   // Open the modal
              setSelectedService(object) //selecting the ID of servicecall
            },
            key: `helper-${object.id}`
          });
        }
        if (object.STATUS === 'ACTIVATED') {
          links.push({
            name: 'Clear Assigned',
            click: () => handleClearAssigned(object.id),
            key: `clear_assigned-${object.id}`
          });
          links.push({
            name: 'Add Helper',
            click: () => {
              setSelectedServiceCall(object); // Set the currently selected service call
              setIsModalOpen(true);  // Open the modal
              setSelectedService(object) //selecting the ID of servicecall
            },
            key: `helper-${object.id}`
          });

        }
        if (object.STATUS === 'INCOMPLETE') {
          links.push({
            name: 'Re-Schedule',
            click: () => handleReschedule(object.id),
            key: `reschedule-${object.id}`
          });
          links.push({
            name: 'Completed',
            click: () => handleCompleteStatus(object.id),
            key: `complete-${object.id}`
          });
        }
        if (object.STATUS === 'PENDING') {
          links.push({
            name: 'Assign',
            click: () => {
              setSelectedService(object) //selecting the ID of servicecall
              setIsModalOpenLead(true)
              setAssignedCalls(fetchItems.filter(item => item.STATUS === 'ASSIGNED' || item.STATUS === 'ACTIVATED'));
            },
            key: `assign-${object.id}`
          });
        }
        if (object.STATUS === 'VOID') {
          links.push({
            name: 'Unvoid Call',
            click: () => handleUnvoidServiceCall(object.id),
            key: `unvoid-${object.id}`,
          });
        }
        else 
        {
          links.push({
            name: 'Void Call',
            click: () => handleVoidServiceCall(object.id),
            key: `void-${object.id}`,
          });
        }
      
        // if (object.STATUS !== 'ASSIGNED' && object.STATUS !== 'INCOMPLETE' || 
        //     object.STATUS !== 'ACTIVATED' && object.STATUS !== 'INCOMPLETE') {
        //   links.push({
        //     name: 'Delete Call',
        //     click: () => handleDeleteServiceCall(object.id), 
        //     key: `delete-${object.id}` 
        //   });
        // }
      }

      return links
  };

  const handleTechChange = async (employeeId, employeeName, serviceCallId) => {
    const bodyData = {
      status: "assigned",
      tech_id: employeeId,
      id: serviceCallId,  // Pass serviceCallId directly here if it's just the ID
      tech: employeeName
    };

    setLoading(true);

    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.data[0] === 'success') {
        setIsModalOpenLead(false);
        setFilterItems(prevItems =>
          prevItems.map(item =>
            item.id === serviceCallId ? { ...item, TECH: employeeName, STATUS: 'ASSIGNED' } : item // Match by serviceCallId
          )
        );
        setFetchItems(prevItems =>
          prevItems.map(item =>
            item.id === serviceCallId ? { ...item, TECH: employeeName, STATUS: 'ASSIGNED' } : item // Match by serviceCallId
          )
        );
        toast.success('Service call successfully assigned!', {
          position: 'top-center',
        });
      } else {
        toast.info("Failed to assign call.", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center",
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      toast.error("No file selected.", { position: 'top-center' });
      setFile(null);
      return;
    }

    const validFileTypes = ['application/pdf'];
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes

    if (!validFileTypes.includes(selectedFile.type)) {
      toast.error("Invalid file type. Only PDF is allowed.", { position: 'top-center' });
      setFile(null);
      return;
    }

    if (selectedFile.size > maxSize) {
      toast.error("File size exceeds 2MB.", { position: 'top-center' });
      setFile(null);
      return;
    }

    setFile(selectedFile);
  };

  const handleUploadFile = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error("Please select a file before uploading.", { position: 'top-center' });
      return;
    }
    
    const formData = new FormData();
    formData.append('status', 'submit_invoice_file');
    formData.append('id', selectInvoiceFile); // Include the accounting vendor ID
    formData.append('file', file);

    try {
      const response = await axios.post(`${apiUrl}/service_file_invoice.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (response.data.success) {
        toast.info('File uploaded successfully!', { position: 'top-center' });

        // Update the state with the new file information
        setFilterItems(prevItems =>
            prevItems.map(item =>
              item.id === selectInvoiceFile ? { ...item, INVOICE: response.data[0] } : item // Set TECH to full name
            )
        );        

        setFile(null);
        setIsModalFileOpen(false);
      } else {
        toast.error(response.data.error || "Error uploading file", { position: 'top-center' });
      }
    } catch (error) {
      toast.error("An error occurred during file upload.", { position: 'top-center' });
      //console.error('Error uploading file', error);
    }
  };

  const handleGenUploadFile = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error("Please select a file before uploading.", { position: 'top-center' });
      return;
    }
    const formData = new FormData();
    formData.append('status', 'submit_gen_file');
    formData.append('id', selectGenFile); // Include the accounting vendor ID
    formData.append('file', file);
    try { 
      const response = await axios.post(`${apiUrl}/service_file_gen.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (response.data.success) {
        toast.info('File uploaded successfully!', { position: 'top-center' });
        // Update the state with the new file information
        setFilterItems(prevItems =>
            prevItems.map(item =>
              item.id === selectGenFile ? { ...item, file_name: response.data[0] } : item // Set TECH to full name
            )
        );

        setFile(null);
        setIsModalFileGenOpen(false);
      } else {
        toast.error(response.data.error || "Error uploading file", { position: 'top-center' });
      }
    } catch (error) {
      toast.error("An error occurred during file upload.", { position: 'top-center' });
      //console.error('Error uploading file', error);
    }
  };

  const handleSearchClick = async () => {
    setLoading(true);
    const bodyData = {
      status: 'searchCall',
      data: { search: searchTerm }
    };
    try {
      const response = await axios.post(api, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data && Array.isArray(response.data)) {
        setFilterItems(response.data);
      } else {
        setFilterItems([]);
        toast.error('Not found: ' + searchTerm, { position: 'top-center' });
      }
    } catch (error) {     
      if (error.response && error.response.status === 401) {
      toast.error("Session expired. Please login again.", {
      position: "top-center"
      });
      navigate('/login');
      } else if (error.response && error.response.status === 403) {
      toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
      position: "top-center"
      });
      }
    } finally {
      setLoading(false);
    }
  };

  function getRowClassName(object, index) {
        let backgroundClass = '';

        if (object.STATUS === 'INCOMPLETE') 
        {
          backgroundClass = 'bg-red-100'; // Light red
        } 
        else if (object.STATUS === 'PENDING') 
        {
          backgroundClass = 'bg-blue-100'; // Light blue
        } 
        else if (
                  (object.INVOICE === 'READY' && object.TYPE === 'CHARGE') ||
                  (object.INVOICE === 'READY' && object.TYPE === null) 
                  // (object.INVOICE !== '' && object.TYPE === null)
                ) 
        {
          backgroundClass = 'bg-green-100'; // Light green
        } 
        else if (object.TYPE === 'NO CHARGE') 
        {
          backgroundClass = 'bg-orange-100'; // Light orange
        } 
        else if (object.STATUS === 'ASSIGNED') 
        {
          backgroundClass = 'bg-yellow-100'; // Light yellow
        } 
        else if (index % 2 === 0) 
        {
          // Default alternating colors for even rows
          backgroundClass = 'bg-white';
        } 
        else 
        {
          // Default alternating colors for odd rows
          backgroundClass = 'bg-gray-100';
        }

        return classNames(
          backgroundClass,
          'divide-x',
          'divide-gray-300',
          'divide-y'
        );
  }

  const submitActualHrs = async (e) => {
    // 3) Form submission
    e.preventDefault();
    const formData = new FormData(e.target);
    const enteredHrs = formData.get('actual_hours');
    const hourTypedEntered = formData.get('hour_type');

    const dataBase = {
      status: 'update_hours',
      data: {
        hour_id: hoursId,
        call_id: callId,
        hour_type: hourTypedEntered,
        total_hours: enteredHrs,
        tech_id: techId
      }
    }
    try {
      const response = await axios.post(api, {   
        status: 'update_hours',
        data: {
          hour_id: hoursId,
          call_id: callId,
          hour_type: hourTypedEntered,
          total_hours: parseInt(enteredHrs),
          tech_id: techId
        } 
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data[0] === 'success') {
        toast.success('Hours updated!', { position: 'top-center' });
        if(hoursId === null) {
          fetchServiceCalls();
        }
        else {
          setFilterItems(prevItems =>
            prevItems.map(item =>
              item.id === callId ? { ...item, hour_total: enteredHrs, hour_type: hourTypedEntered} : item // Update the specific item
            )
          );
        }
      } else {
        toast.error(response.data.error || 'Error updating actual hours', { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error updating actual hrs', error);
      toast.error('Error updating actual hours', { position: 'top-center' });
    } finally {
      setShowHrsModel(false);
      setHoursId(null);
    }
  };

  // const handleHrsUpdate = (call_id, hour_id, tech_id) => {
  //   setCallId(call_id);
  //   setHoursId(hour_id);
  //   setTechId(tech_id);
  //   setShowHrsModel(true);
  // };  
  const handleHrsUpdate = (item) => {
    setCompletedHours(Array.isArray(item?.hours) ? item.hours : []);
    const hour_id = item?.hours && item.hours.length > 0 ? item.hours[0].id : null;
    const call_id = item.id;
    const tech_id = item.tech_id;
    setCallId(item.id);
    setHoursId(hour_id);
    setTechId(tech_id); 
    setShowHrsModel(true);   
  };   

  //**************** the code below is add part ****************
  const fetchServiceCallParts = async (id) => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/service_crud.php?getPartsService=${id}`, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      });
      
      if (response.data[0] === 'success') {
        //adding parts        
        const partDevice = Array.isArray(response.data.add_parts) ? response.data.add_parts : [];
        setPartsList(partDevice || [])
      } else {
        toast.error(response.data.error, { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! you don't have access to this area. Speak to the CFO.", { position: "top-center" });
      }
    } finally {
      setLoading(false);
    }
  };  

  const handlePartSelect = newPart => {
    if (newPart && newPart.part) {
      setSelectedParts(newPart);
      setParts(prev => ({
        ...prev,
        part: newPart.part,
        id: newPart.id
      }));
    } else {
      //console.error('Invalid company selected:', newCompany);
    }
  };

  const handleAddParts = async() => {
    setLoading(true);
    const isAlreadyAdded = partsList.some((part) => part.part === selectParts.part); // Convert both to numbers
    
    if (isAlreadyAdded) {
      toast.info(selectParts.part+' has already been added.', { position: 'top-center' });
      setSelectedParts('');
      setLoading(false);
      return; // Prevent adding duplicate tech
    }
    
    const bodyData = {
      status: "addParts",
      id: callId,
      parts_quantity: parseInt(servicePart.quantity),
      part: selectParts.part
    };
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data[0] === 'success') {
        const newPartAdded = Array.isArray(response.data[1]) ? response.data[1] : [response.data[1]];
        setPartsList((prevPart) => [...prevPart, ...newPartAdded]);
        toast.success('Part added!', {
          position: 'top-center',
        });
        setSelectedParts('');
      } else {
        toast.info("Failed to add part", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center"
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", {
          position: "top-center"
        });
      }
    } finally {
      setLoading(false);
    }    
  }

  const handlePartsChange = (e) => {
     setServicePart({ ...servicePart, quantity: e.target.value });
  };

  const handleRemovePart = async(partId) => {
        setLoading(true);
    const bodyAddData = {
      status: "removePart",
      removePartId: partId,
    };

    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyAddData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data[0] === 'success') {
          setPartsList(partsList.filter((part) => part.id !== response.data[1]));
          toast.success('Part removed!', { position: 'top-center' });
          // toggleAccordion();
      } else {
        toast.info("Failed to remove part", { position: "top-center" });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", { position: "top-center" });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", { position: 'top-center' });
      }
    } finally {
      setLoading(false);
    }
  } 

  const handlePartsUpdate = (call_id) => {
    setCallId(call_id);
    fetchServiceCallParts(call_id);
    // setTechId(tech_id);
    setShowPartsModel(true);
  };      
 
  // 1) Form submission for adding hold
  const submitAddHold = async (e) => {
  e.preventDefault();
  const formData = new FormData(e.target);
  const hold_amount = parseFloat(formData.get('hold_amount') || 0);

  if (!holdContractId || hold_amount <= 0) {
    toast.error('Enter a valid dollar amount.', { position:'top-center' });
    return;
  }

  try {
    const res = await axios.post(api, {
      status : 'addHold',
      data   : { contract_id: holdContractId, contract_hold_amount: hold_amount }
    }, { headers:{ 'Content-Type':'application/json' } });

    if (res.data?.success) {
      toast.success('Hold saved!', { position:'top-center' });

      // update UI – mark the contract as on-hold and keep the amount
      setFilterItems(prev =>
        prev.map(c =>
          c.maintenance_id === holdContractId
            ? {
                ...c,
                contract_details: {
                  ...c.contract_details,
                  contract_hold : 1,
                  contract_hold_amount: hold_amount,
                  contract_hold_date  : res.data.date_on_hold   // if backend returns it
                }
              }
            : c
        )
      );
      setShowHoldModal(false);
      setHoldContractId(null);
    } else {
      toast.error(res.data?.error || 'Could not save hold.', { position:'top-center' });
    }
  } catch (err) {
    toast.error('Server error.', { position:'top-center' });
  }
  };

  // Toggle billing_complete between 1 and 0
  const handleBillingComplete = async (service_call_id, billingComplete) => {
    // billingComplete = billingComplete === 1 ? 0 : 1;
    try {
      const response = await axios.post(
        api,
        {
          status: 'billingComplete',
          data: {
            service_call_id: service_call_id,
            billing_complete: billingComplete,
          },
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      
      if (response.data.success) {
        toast.success('updated!', { position: 'top-center' });
        setFilterItems(prev =>
          prev.map(item =>
            item.id === service_call_id
              ? { ...item, billing_complete: billingComplete }
              : item
          )
        );
      } else {
        toast.error(response.data.error || 'Error updating', { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error updating billing', error);
      toast.error('Error updating billing', { position: 'top-center' });
    }
  };  

  const handleSaveTechNotes = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, {
        status: 'updateTechNotes',
        id: editTechNotesId,
        tech_notes: techNotesValue
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
      if(response.data.success) {
        toast.success('Tech notes updated!', { position: 'top-center' });
        // Optionally update UI immediately:
        setFilterItems(prev =>
          prev.map(item =>
            item.id === editTechNotesId ? { ...item, TECHNOTES: techNotesValue } : item
          )
        );
        setEditTechNotesId(null);
      } else {
        toast.error(response.data.error || 'Error updating tech notes', { position: 'top-center' });  
      }    
    } catch {
      toast.error('Error updating tech notes', { position: 'top-center' });
    }
     finally {
      setLoading(false);
    }
  };
   

  // State for Google Drive images
  const handleViewImages = async (serviceCall) => {
      // 1) Check if we have an array of folder references
    if (!serviceCall.service_image || !serviceCall.service_image.length) {
      toast.error('No folders for this serviceCall');
      return;
    }

    try {
      let allFiles = [];
      
      // 2) Loop over each item in service_image
      for (const folderRow of serviceCall.service_image) {
        const folderId = folderRow.image_name;  // the actual Drive folder ID

        // 3) Call the backend to list files in that folder
        const response = await axios.get(`${apiUrl}/drive_folder.php`, {
          params: {
            status: 'listFiles',
            folderId: folderId
          }
        });
        if (response.data.success && Array.isArray(response.data.files)) {
          // Merge these files into allFiles
          allFiles = [...allFiles, ...response.data.files];
        } else {
          console.warn(`No success for folderId=${folderId}`, response.data);
        }
      }

      // 4) Once all calls are done, store combined files in driveImages
      setDriveImages(allFiles);
      setImagesModalOpen(true);
    } catch (error) {
      console.error('Error listing images across multiple folders:', error);
      toast.error('Error listing images', { position: 'top-center' });
    }
  };  

  const handleDeleteHour = async (hourId) => 
  {
    setLoading(true);
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, {
        status: 'deleteHour',
        hour_id: hourId
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data.success) {
        toast.success('Hour deleted!', { position: 'top-center' });
        setCompletedHours(prevHours => prevHours.filter(hour => hour.id !== hourId));
      } else {
        toast.error(response.data.error || 'Error deleting hour', { position: 'top-center' });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! You don't have access to this area. Speak to the CFO.", { position: 'top-center' });
      }
    } finally {
      setLoading(false);
    }
  }  

  const handleSortByScheduled = () => {
    setFilterItems((prev) => {
      const sorted = [...prev].sort((a, b) => {
        const aDate = a.SCHEDULE_DATE || '';
        const bDate = b.SCHEDULE_DATE || '';

        // Put empty dates at the bottom
        if (!aDate && !bDate) return 0;
        if (!aDate) return 1;
        if (!bDate) return -1;

        // Assuming SCHEDULE_DATE is in YYYY-MM-DD format, string compare works
        return scheduleSortDir === 'asc'
          ? aDate.localeCompare(bDate)
          : bDate.localeCompare(aDate);
      });

      return sorted;
    });

    setScheduleSortDir((prev) => (prev === 'asc' ? 'desc' : 'asc'));
  };


  return (
    <div className="mx-auto max-w-6xl w-full px-2 sm:px-6 lg:px-8 py-6">
      <HeadingCp label={"Service Dashboard"} />
      <div className="flex items-center mb-4 space-x-10 bg-slate-100 p-2 rounded-lg">
        {totalCalls && totalCalls.last_month && (
          <p className='text-sm text-gray-600 mb-4'>
            Total Logged Calls (Last Month): <span className="font-bold"> {totalCalls.last_month.logged_calls}</span>
            <span className="ml-2 text-xs text-gray-500">
              ({totalCalls.last_month.label})
            </span>
          </p>
        )}

        {totalCalls && totalCalls.last_month && (
          <p className='text-sm text-gray-600 mb-4'>
            Total Scheduled Calls (Last Month): <span className="font-bold"> {totalCalls.last_month.scheduled_calls}</span>
            <span className="ml-2 text-xs text-gray-500">
              ({totalCalls.last_month.label})
            </span>
          </p>
        )}

        {totalCalls && totalCalls.current_month && (
          <p className='text-sm text-green-600 mb-4'>
            Total Logged Calls (Current Month): <span className="font-bold"> {totalCalls.current_month.logged_calls}</span>
            <span className="ml-2 text-xs text-gray-500">
              ({totalCalls.current_month.label})
            </span>
          </p>
        )}
        
        {totalCalls && totalCalls.current_month && (
          <p className='text-sm text-green-600 mb-4'>
            Total Scheduled Calls (Current Month): <span className="font-bold"> {totalCalls.current_month.scheduled_calls}</span>
            <span className="ml-2 text-xs text-gray-500">
              ({totalCalls.current_month.label})
            </span>
          </p>
        )}

      </div>
      <div className="flex flex-wrap gap-2 mb-4">
        <LegendCP color="fill-red-300" label="Incomplete" />
        <LegendCP color="fill-green-400" label="Invoice Ready" />
        <LegendCP color="fill-orange-600" label="No Charge" />
        <LegendCP color="fill-yellow-300" label="Assigned" />
        <LegendCP color="fill-blue-300" label="Pending" />
      </div>
  
      {/* Responsive filter bar */}
      <div className="flex flex-col sm:flex-row items-center justify-between bg-gray-100 p-4 rounded-lg shadow-md">
        <div className="mt-6 flex flex-col sm:flex-row flex-wrap gap-2 items-stretch sm:items-center">
          {/* Navigation Buttons */}
          <NavLink to="/full_scheduler_viewer" className="hidden sm:inline-flex">
            <button type="button" className="w-full sm:w-auto px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-yellow-400 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500">
              Full Scheduler
            </button>
          </NavLink>
          <NavLink to="/service_new/new" className="hidden sm:inline-flex">
            <button type="button" className="w-full sm:w-auto px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-400 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500">
              New Service Call +
            </button>
          </NavLink>
          <NavLink to="/service_report" className="hidden sm:inline-flex">
            <button type="button" className="w-full sm:w-auto px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
              Report
            </button>
          </NavLink>
          <NavLink to={`/service_cal`} className="hidden sm:inline-flex">
            <button type="button" className="w-full sm:w-auto px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
              Service Calendar
            </button>
          </NavLink>
        </div>

        {/* New line for Filters */}
        <div className="flex flex-wrap gap-2 mt-2 items-center">
          <select
            className="border border-gray-300 rounded-md px-2 py-2 w-full sm:w-auto"
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
          >
            <option value="ALL">All</option>
            <option value="ASSIGNED">Assigned</option>
            <option value="PENDING">Pending</option>
            <option value="VOID">Void</option>
            <option value="COMPLETED">Completed</option>
            <option value="READY">Ready</option>
            <option value="NOT READY">Not Ready</option>
            <option value="INCOMPLETE">Incomplete</option>
            <option value="not_invoiced">Not Invoiced</option>
            <option value="invoiced">Invoiced</option>
          </select>

          <input
            type="date"
            className="border border-gray-300 rounded-md px-2 py-2 w-full sm:w-auto"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
          />

          <span className="flex items-center px-2 sm:px-0 justify-start">to</span>

          <input
            type="date"
            className="border border-gray-300 rounded-md px-2 py-2 w-full sm:w-auto"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
          />

          <select onChange={(e) => setFilterEmployee(e.target.value)} className="border border-gray-300 rounded-md px-2 py-2 w-full sm:w-auto">
            <option value="">Select Employee</option>
            {employees && employees.length > 0 ? (
              employees.map((employee) => (
                <option key={employee.id} value={employee.first_name + ' ' + employee.last_name}>
                  {employee.first_name} {employee.last_name}
                </option>
              ))
            ) : (
              <option value="" disabled>
                No employees found
              </option>
            )}
          </select>

          <button
            type="button"
            onClick={handleFilter}
            className="w-full sm:w-auto px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Filter
          </button>
        </div>
      </div>
  
      <div className="mt-4 flow-root">
        <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
          {/* Mobile scrollable table */}
          <div className="inline-block min-w-full py-2 align-middle">
            {loading ? (
              <LoadingSpinner>Loading...</LoadingSpinner>
            ) : (
              // <div className="shadow ring-1 ring-black ring-opacity-5 rounded">
            <div className="px-2 sm:px-0">
              <div className="flex-grow mb-3">
                <SearchBarCP
                  search={searchTerm}
                  handleChange={(e) => setSearchTerm(e.target.value)}
                  onClick={handleSearchClick}
                />
              </div>
              <table className="min-w-full table-auto border-separate border-spacing-0 text-xs sm:text-sm">
                <thead className="top-0 z-30 bg-white">
                  <tr>
                    <th className="hidden sm:table-cell top-0 z-30 border-b border-gray-300 bg-white bg-opacity-75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8">
                      MenuId
                    </th>
                    <th className="hidden sm:table-cell top-0 z-30 border-b border-gray-300 bg-white bg-opacity-75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8">
                      User|Time-Stamp
                    </th>
                    <th className="top-0 z-30 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:table-cell">
                      Job Site | Customer
                    </th>
                    <th className="top-0 z-30 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter lg:table-cell">
                      Condition
                    </th>
                    <th className="hidden sm:table-cell top-0 z-30 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Called By
                    </th>
                    {filterStatus === 'ASSIGNED' ? (
                    <th 
                     onClick={handleSortByScheduled}
                      className={`hidden sm:table-cell top-0 z-30 border-b border-gray-300 bg-white 
                                 bg-opacity-75 py-3.5 pl-3 pr-4 backdrop-blur backdrop-filter sm:pr-6 
                                 lg:pr-8 select-none underline text-blue-500 cursor-pointer`}>
                      Tech | Scheduled
                      <span className="ml-1 text-xs">
                          {scheduleSortDir === 'asc' ? '↑' : '↓'}
                      </span>
                    </th>                    
                    ) : (
                      <th className="hidden sm:table-cell top-0 z-30 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                        Tech | Scheduled
                      </th>
                    )}
                    <th className="hidden sm:table-cell top-0 z-30 border-b border-gray-300 bg-white bg-opacity-75 py-3.5 pl-3 pr-4 backdrop-blur backdrop-filter sm:pr-6 lg:pr-8">
                      File
                    </th>
                    <th className="hidden sm:table-cell top-0 z-30 border-b border-gray-300 bg-white bg-opacity-75 py-3.5 pl-3 pr-4 backdrop-blur backdrop-filter sm:pr-6 lg:pr-8">
                      Notes
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filterItems.map((object, objectIdx) => (
                    <tr key={object.id} className={getRowClassName(object, objectIdx)} onClick={() => {
                      if (window.innerWidth < 640) setDetailsModal({ open: true, object });
                    }}
                    >
                      <td className={classNames(
                          objectIdx !== filterItems.length - 1 ? 'border-b border-gray-200' : '',
                          'hidden sm:table-cell py-2 pl-4 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-2',
                          object.STATUS === 'VOID' ? 'line-through text-red-500' : '')}>
                        <span className='text-xs text-green-700 font-bold'>
                          {object.STATUS === 'ACTIVATED' ? 'Activated' : ''}
                        </span>
                        <span className='text-xs text-yellow-700 font-bold'>
                          {object.STATUS === 'tentative' ? 'Tentative' : ''}
                        </span>
                        <SubMenu label={object.id} idItem={object.id} links={getLinksForJob(object)} />
                        {object.billing_complete === 1 && (
                        <span>
                          <CheckBadgeIcon className="w-5 text-blue-700 font-extrabold" />
                        </span>
                        )}    
                      </td>

                      {/* ****On Call**** */}
                      <td
                        className={classNames(
                          objectIdx !== filterItems.length - 1 ? 'border-b border-gray-200' : '',
                          'hidden sm:table-cell  py-2 pl-2 px-4 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-2',
                          object.STATUS === 'VOID' ? 'line-through text-red-500' : ''
                        )}
                      >
                        <div className="flex flex-col">
                          <span className="text-gray-800 text-xs">
                            <DateFormat date={object.DATE} /> | {object.TIME_LOG}
                          </span>

                          {/* make USER green if NOTES includes "****On Call****" */}
                          <span
                            className={classNames(
                              object.NOTES?.includes('****on call****')
                                ? 'text-purple-600'
                                : 'text-gray-400'
                            )}
                          >
                            {object.USER}
                          </span>

                          {/* and show "***on call***" underneath in green */}
                          {object.NOTES?.includes('****on call****') && (
                            <span className="text-purple-600 text-xs italic">***on call***</span>
                          )}
                        </div>
                      </td>

                      {/* jobsite | customer */}
                      <td className={classNames('px-4', object.STATUS === 'VOID' ? 'line-through text-red-500' : '')}>
                        <div className="flex flex-col">
                          <span className="text-gray-800 text-sm">{object.ADDRESS}</span>
                          <span className="text-gray-400 text-xs">{object.CUSTOMER}</span>
                        </div>
                      </td>
                      
                      {/* trouble */}
                      <td className={classNames(
                          'px-4 py-2',
                          'max-w-xs',          // Limits max width (~20rem)
                          'break-words',         //// Breaks only at word boundaries
                          object.STATUS === 'VOID' ? 'line-through text-red-500' : ''
                        )} >
                        <span className="text-gray-800 text-xs whitespace-pre-line">
                          {object.TROUBLE}
                        </span>
                        <br />
                        {object.inspection_id > 0 && (
                          <NavLink className="text-blue-700 font-bold" to={`/maintenance_ticket/${object.inspection_id}`} target="_blank" rel="noopener noreferrer">
                            <DocumentTextIcon className="w-5 text-blue-700 font-bold inline" />
                          </NavLink>
                        )}
                        {object.comment && 
                          <span onClick={() => setShowTechComment(object.id)}> | <ChatBubbleBottomCenterIcon className="w-5 text-blue-700 font-bold inline hover:cursor-pointer" /></span>
                        }
                        {showTechComment === object.id && (
                          <ModalWindow job={object.comment} closeNotes={() => setShowTechComment(null)} activeButton={true} />
                        )}
                      </td>
                      
                      {/* phone */}
                      <td className={classNames('hidden sm:table-cell px-4', object.STATUS === 'VOID' ? 'line-through text-red-500' : '')}>
                        <div className="flex flex-col">
                          <span className="text-gray-800 text-sm">{object.CALLED_BY}</span>
                          <span className="text-gray-600 text-xs">
                            <PhoneNumber number={object.PHONE} />
                          </span>
                        </div>
                      </td>
                      
                      {/* Tech */}
                      <td className={classNames(object.STATUS === 'VOID' ? 'line-through text-red-500' : '', 'hidden sm:table-cell px-3')}>
                        <span className="text-gray-800 text-xs">
                          {object.TECH ? (
                            <>
                              <span className="text-orange-800 hover:cursor-pointer hover:text-blue-800" onClick={() => handleTechFilter (object.TECH)}>
                                {object.TECH}
                              </span><br/>
                              
                              {/* Check if there are any additional techs */}
                              {object.add_tech && object.add_tech.length > 0 && (
                                <>
                                  {object.add_tech.map((additionalTech, index) => (
                                    <span key={index} className="text-gray-800">| {additionalTech.tech_name} 
                                    </span>
                                  ))}
                                </>
                              )}
                            </>
                          ) : (
                            'no assignment'
                          )}
                          <br />
                          {object.SCHEDULE_DATE && (
                          <span className="text-xs text-green-700">
                            <DateFormat date={object.SCHEDULE_DATE} />
                          </span>
                        )}
                        </span>
                      </td>
                      
                      {/* files */}
                      <td className={classNames('hidden sm:table-cell px-4', object.STATUS === 'VOID' ? 'line-through text-red-500' : '')}>
                        <span className='text-green-700'><ServiceInvoiceFileLocation expFile={object.INVOICE} where={'service_file'} /></span>
                        <span className='text-gray-700'><ServiceGenFileLocation expFile={object.file_name} where={'service_file'} /></span>
                        <span className='text-gray-700 p-1'>
                          {object.STATUS === 'COMPLETED' && (
                            <NavLink
                              to={`/service_ticket/${object.id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <DocumentCheckIcon className="w-5" />
                              {/* You can add something here if you want, or leave it blank */}
                            </NavLink>
                          )}
                        </span>

                    <span>
                      {/* if you store multiple images in Google Drive, show a “View Images” button */}
                      {object.service_image && (
                        <button
                          onClick={() => handleViewImages(object)}
                          className="flex items-center gap-1 text-blue-700 hover:underline"
                        >
                          <PhotoIcon className="w-5 text-blue-600 font-bold" />
                          Images
                        </button>
                      )}
                    </span>                        
                      </td>
                      
                      {/* Notes */}
                      <td className={classNames('hidden sm:table-cell px-2', object.STATUS === 'VOID' ? 'line-through text-red-500' : '')}>
                        <span className="text-gray-800 text-xs">
                          {/* {object.NOTES} */}
                          {object.NOTES && 
                            <Truncate text={object.NOTES} handleNotesView={() => handleNotesView(object.id)} />
                          }
                          {notesIdOpen === object.id && (
                            <ModalWindow job={object.NOTES} closeNotes={() => setNotesIdOpen(null)} activeButton={true} />
                          )}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              
            {/* file invoice upload */}
            {isModalFileOpen && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-600 bg-opacity-50">
                <div className="bg-white p-8 rounded-md shadow-md min-w-[500px]">
                  <h2 className="text-xl font-semibold mb-4">Upload Invoice File</h2>
                  <form onSubmit={handleUploadFile}>
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Select a PDF file (Max size 2MB)</label>
                      <input
                        type="file"
                        accept="application/pdf"
                        onChange={handleFileChange}
                        className="mt-2"
                      />
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={() => setIsModalFileOpen(false)}
                        className="px-4 py-2 mr-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700"
                      >
                        Upload
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* file upload */}
            {isModalFileGenOpen && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-600 bg-opacity-50">
                <div className="bg-white p-8 rounded-md shadow-md min-w-[500px]">
                  <h2 className="text-xl font-semibold mb-4">Upload File</h2>
                  <form onSubmit={handleGenUploadFile}>
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Select a PDF file (Max size 2MB)</label>
                      <input
                        type="file"
                        accept="application/pdf"
                        onChange={handleFileChange}
                        className="mt-2"
                      />
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={() => setIsModalFileGenOpen(false)}
                        className="px-4 py-2 mr-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700"
                      >
                        Upload
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* Add Tech Modal */} 
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
              { selectedService && Array.isArray(selectedService.add_tech) && selectedService.add_tech.length > 0 ? (
                <ul className="list-disc pl-4 mb-3">
                  {selectedService.add_tech.map((tech) => (
                    <li key={tech.id} className="bg-gray-100 py-2 mb-2 rounded flex items-center">
                      <span className="mr-2 hover:cursor-pointer" onClick={() => handleRemoveTech(tech.id)}>
                        <TrashIcon className="h-5 text-red-600" />
                      </span>
                      <span>{tech.tech_name}</span>
                    </li>
                  ))}
                </ul>
              ) : null }
              <h2 className="text-lg font-semibold text-gray-900">Add Helper</h2>
              <select className="border border-gray-300 rounded-md px-6 py-2 w-full"
                  value={addTech.additional_tech || ''}
                  onChange={(e) => {
                    const selectedOption = e.target.options[e.target.selectedIndex];
                    const employeeId = e.target.value;
                    const employeeName = selectedOption.textContent;
                    handleAdditionalTech(employeeId, employeeName, selectedService); 
                  }}
              >
                <option value="">Select Employee</option>
                {employees && employees.length > 0 ? (
                  employees.map((employee) => (
                    <option key={employee.id} className="sm:text-lg" value={employee.id}>
                      {employee.first_name} {employee.last_name}
                    </option>
                  ))
                ) : (
                  <option value="" disabled>
                    No employees found
                  </option>
                )}
              </select>
            </Modal>

            {/* ADD Lead Tech */} 
            <Modal isOpen={isModalOpenLead} onClose={() => setIsModalOpenLead(false)}>
           <h2 className="text-lg font-semibold text-gray-900">Lead Tech</h2>
              <select className="border border-gray-300 rounded-md px-6 py-2 w-full"
                  value={addTech.additional_tech || ''}
                  onChange={(e) => {
                    const selectedOption = e.target.options[e.target.selectedIndex];
                    const employeeId = e.target.value;
                    const employeeName = selectedOption.textContent;
                    handleTechChange(employeeId, employeeName, selectedService.id); 
                  }}
              >
                <option value="">Select Employee</option>
                {employees && employees.length > 0 ? (
                  employees.map((employee) => (
                    <option key={employee.id} className="sm:text-lg" value={employee.id}>
                      {employee.first_name} {employee.last_name}
                    </option>
                  ))
                ) : (
                  <option value="" disabled>
                    No employees found
                  </option>
                )}
              </select>

              {/* 2) list of "calls" with images and details */}
              {assignedCalls.length > 0 && (
                <>
                {assignedCalls.map((item) => ( 
                  <ul key={item.id} className="divide-y divide-gray-200 border-b border-gray-200">
                  <li className="flex justify-between gap-x-6 py-3">
                    <div className="flex min-w-0 gap-x-4">
                      <div className="min-w-0 flex-auto">
                        <p className="text-sm/6 font-semibold text-gray-900">
                          {item.ADDRESS}
                        </p>
                        <p className="truncate text-xs/5 text-gray-500">
                          {item.CUSTOMER} 
                        </p>
                        <p className="truncate text-xs/5 text-blue-500">
                          {item.TECH} 
                        </p>                        
                      </div>
                    </div>

                    <div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                        <p className="mt-1 text-xs/5 text-gray-500">
                          <span className={`text-xs ${item.STATUS === 'ACTIVATED' ? 'text-green-500' : 'text-yellow-500'}`}>{item.STATUS}</span>
                        </p>
                        <p className="mt-1 text-xs/5 text-gray-500">
                          Logged <time dateTime={item.TIME_LOG}>{item.TIME_LOG}</time>
                        </p>
                        <div className="mt-1 flex items-center gap-x-1.5">
                          <p className="text-xs/5 text-gray-500">{item.SCHEDULE_DATE}</p>
                        </div>
                    </div>
                  </li>
                  </ul>
                ))}
                </>
              )}
            </Modal>

            {/* add hours */}
            {showHrsModel && (
              <ModalWindow
                closeNotes={() => {
                  setShowHrsModel(false);
                  setHoursId(null);
                }}
                job={
                  <div className="max-w-">
                    <h2 className="text-lg font-semibold mb-4">
                      Update Hours For (Service Call Log ID: {callId})
                    </h2>
                    <div>
                      {completedHours && completedHours.length > 0 ? (
                        <ul className="list-disc pl-4 mb-3">
                          {completedHours.map((hr) => (
                            <li key={hr.id} className="bg-gray-100 p-2 mb-2 rounded flex items-center justify-between">
                              <span>{hr.hour_type}: {hr.total_hours} hrs</span>
                              <span><TrashIcon className="h-4 w-4 text-red-500 cursor-pointer" onClick={() => handleDeleteHour(hr.id)} /></span>
                              {/* <span className="text-xs text-gray-500">({hr.tech_name})</span> */}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-sm text-gray-500 mb-3">No hours logged yet.</p>
                      )}
                    </div>
                    <form onSubmit={submitActualHrs}>
                      <div className="mb-4">
                        <label htmlFor="actual_hours" className="block text-sm font-medium text-gray-700">
                          Update Hours:
                        </label>
                        <input
                          type="number"
                          name="actual_hours"
                          id="actual_hours"
                          required className="mt-1 block w-full border rounded p-1" />
                      </div>

                      <div className="flex items-center space-x-2 mb-3">
                        <select
                          name="hour_type"
                          id="hour_type"
                          defaultValue=""
                          className="w-full border border-gray-300 rounded-md px-4 py-2"
                          required
                        >
                          <option value="">Select Hour Type</option>
                          <option value="Overtime">Overtime</option>
                          <option value="Regular">Regular</option>
                          <option value="Holiday">Holiday/Sunday</option>
                        </select>
                      </div>

                      <div className="flex justify-end">
                        <button
                          type="button"
                          onClick={() => {
                            setShowHrsModel(false);
                            setHoursId(null);
                            setCallId(null);
                          }}
                          className="mr-2 px-4 py-2 bg-gray-500 text-white rounded"
                        >
                          Close
                        </button>
                        <button
                          type="submit"
                          className="px-4 py-2 bg-blue-500 text-white rounded"
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                }
              />
            )}

            {/* Render the SlideOverPanel conditionally */}
            <SlideOverPanel 
              open={openPanel} 
              onClose={() => setOpenPanel(false)} 
            />

            {/* add parts */}
            {showPartsModel && (
              <ModalWindow
                closeNotes={() => {
                  setShowHrsModel(false);
                  setParts(null);
                }}
                job={
                    <>
                      <ul className="list-disc pl-4 mb-3">
                        {partsList.map((x) => (
                          <li key={x.id} className="bg-gray-100 py-2 mb-2 rounded flex items-center">
                            <span className="mr-2 hover:cursor-pointer" onClick={() => handleRemovePart(x.id)}>
                              <TrashIcon className="h-5 text-red-600" />
                            </span>
                            <span>{x.part} x {x.quantity}</span>
                          </li>
                        ))}
                      </ul>


                      {/* Part description and quantity side by side */}
                      <div className="flex space-x-2 mb-3">
                        <div className="flex-1 rounded-md py-2 w-[70%]">
                          <SelectParts
                            label="find part"
                            items={parts}
                            selectedItem={selectParts}
                            setSelectedItem={handlePartSelect}
                            apiUrl={`${apiUrl}/service_crud.php`}
                          />
                        </div>
                        <input
                          type="number"
                          name="quantity"
                          placeholder="Quantity"
                          value={servicePart.quantity}
                          onChange={handlePartsChange}
                          required
                          className="border border-gray-300 rounded-md px-2 py-2 w-1/4 mt-2 h-full"
                        />
                      </div>

                      {/* Buttons below inputs */}
                      <div className="flex space-x-4 mt-4">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded text-md" onClick={handleAddParts}>
                          Add Parts
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            setShowPartsModel(false);
                            setParts(null);
                            setCallId(null);
                          }}
                          className="mr-2 px-4 py-2 bg-gray-500 text-white rounded">
                          Close
                        </button>
                      </div>
                    </>                  
                }/>
            )}

            {/* hold */}
            {showHoldModal && (
              <ModalWindow
                closeNotes={() => { setShowHoldModal(false); setHoldContractId(null); }}
                job={
                  <div className="max-w-sm">
                    <h2 className="text-lg font-semibold mb-4">
                      Add Hold – Contract&nbsp;#{holdContractId}
                    </h2>

                    <form onSubmit={submitAddHold}>
                      <label className="block mb-4">
                        <span className="text-sm font-medium text-gray-700">Hold Amount ($)</span>
                        <input
                          type="number"
                          name="hold_amount"
                          step="0.01"
                          min="0"
                          required
                          className="mt-1 block w-full border rounded p-1"
                        />
                      </label>

                      <div className="flex justify-end">
                        <button
                          type="button"
                          onClick={() => { setShowHoldModal(false); setHoldContractId(null);} }
                          className="mr-2 px-4 py-2 bg-gray-500 text-white rounded">
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="px-4 py-2 bg-blue-500 text-white rounded">
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                }
              />
            )} 

            {detailsModal.open && detailsModal.object && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white rounded p-6 w-11/12 max-w-md">
                  <div className="flex justify-between items-center mb-2">
                    <h2 className="text-lg font-semibold">Details</h2>
                    <button
                      className="text-red-600 font-bold text-xl"
                      onClick={() => setDetailsModal({ open: false, object: null })}
                    >
                      ×
                    </button>
                  </div>
                  <div className="mb-2">
                    <span className="font-semibold">MenuId: </span>
                    {detailsModal.object.id}
                  </div>
                  <div className="mb-2">
                    <span className="font-semibold">Called By: </span>
                    {detailsModal.object.CALLED_BY}
                  </div>
                  <div className="mb-2">
                    <span className="font-semibold">Phone: </span>
                    <PhoneNumber number={detailsModal.object.PHONE} />
                  </div>
                  <div className="mb-2">
                    <span className="font-semibold">Tech: </span>
                    {detailsModal.object.TECH || "no assignment"}
                    {detailsModal.object.add_tech && detailsModal.object.add_tech.length > 0 &&
                      detailsModal.object.add_tech.map((t, i) => (
                        <span key={i}> | {t.tech_name}</span>
                      ))}
                  </div>
                  <div className="mb-2">
                    <span className="font-semibold">File: </span>
                    <ServiceInvoiceFileLocation expFile={detailsModal.object.INVOICE} where={"service_file"} />
                    <ServiceGenFileLocation expFile={detailsModal.object.file_name} where={"service_file"} />
                  </div>
                  <div className="mb-2">
                    <span className="font-semibold">Notes: </span>
                    {detailsModal.object.NOTES && (
                      <Truncate
                        text={detailsModal.object.NOTES}
                        handleNotesView={() => handleNotesView(detailsModal.object.id)}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* // Edit Tech Notes Modal */}
            <Modal isOpen={!!editTechNotesId} onClose={() => setEditTechNotesId(null)}>
            <h2 className="text-lg font-semibold mb-4">Edit Tech Notes for service call log# {editTechNotesId}</h2>
              <textarea
                className="block w-full border border-gray-300 rounded mb-4 p-2"
                rows={5}
                value={techNotesValue}
                onChange={(e) => setTechNotesValue(e.target.value)}
                placeholder="Enter technician notes here"
              />
              <div className="flex justify-end gap-2">
                <button
                  className="bg-green-600 text-white px-4 py-2 rounded"
                  onClick={handleSaveTechNotes}
                >
                  Save
                </button>
                <button
                  className="bg-gray-400 text-white px-4 py-2 rounded"
                  onClick={() => setEditTechNotesId(null)}
                >
                  Cancel
                </button>
              </div>
            </Modal>
            </div>
            )}

            {imagesModalOpen && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded p-4 max-w-3xl w-full">
                  <h2 className="text-lg font-bold mb-3">Images for Service Call</h2>
                  <button
                    className="text-red-500 float-right"
                    onClick={() => setImagesModalOpen(false)}
                  >
                    Close
                  </button>
                  <br />
                  <div className="grid grid-cols-3 gap-2 mt-8">
                    {driveImages?.map((file) => (
                      <div key={file.id} className="border p-2">
                        <p className="text-sm font-medium">{file.name}</p>
                        {/* If it's an image, show a preview */}
                        {/* https://drive.google.com/uc?export=view&id=ACTUAL_FILE_ID */}
                        {file?.id && file?.mimeType.startsWith('image/') ? (
                          <>            
                          <NavLink to={file?.webViewLink} target="_blank">
                          <img
                            // src={`https://drive.google.com/uc?export=view&id=${file?.id}`}
                            src={`https://drive.google.com/thumbnail?id=${file?.id}&sz=w1000`}
                            // src={`https://drive.google.com/uc?export=view&id=${file?.id}`}
                            alt="view file"
                            className="mt-2 w-full h-auto object-cover">          
                            </img>
                            </NavLink>         
                          </>
                        ) : (
                          <a
                            href={file.webViewLink}
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-500 underline"
                          >
                            Open file
                          </a>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default ServiceCallList;
